import { FC, ReactElement, useMemo } from 'react'

import { Period } from '@/entities/Period/Period'
import { arePeriodsDeviated } from '@/entities/Period/PeriodHelpers'
import { getPersonFullName } from '@/entities/Person/PersonHelpers'
import { ShiftPlanning } from '@/entities/ShiftPlanning/ShiftPlanning'
import { formatDate } from '@/helpers/date'
import { DateFormat } from '@/types'

import './CalendarShiftPlanning.scss'

export interface CalendarShiftPlanningProps {
    shiftPlanning: ShiftPlanning
    shiftPeriod: Period
    showEndTime?: boolean
    className?: string
}

export const CalendarShiftPlanning: FC<CalendarShiftPlanningProps> = ({
    shiftPlanning,
    shiftPeriod,
    showEndTime = false,
    className = '',
}): ReactElement => {
    const showDeviatedTime = useMemo(() => arePeriodsDeviated(shiftPlanning.period, shiftPeriod), [shiftPlanning.period, shiftPeriod])

    return (
        <div className={`calendar-shift-planning ${className}`}>
            <div className="calendar-shift-planning__employee">{getPersonFullName(shiftPlanning.user)}</div>

            {showDeviatedTime && (
                <div className="calendar-shift-planning__period">
                    {formatDate(shiftPlanning.period.start, DateFormat.hoursMinutes)}
                    {showEndTime && ` - ${formatDate(shiftPlanning.period.end, DateFormat.hoursMinutes)}`}
                </div>
            )}
        </div>
    )
}
